import React, { ReactElement } from 'react';
import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { GridEditor } from '../../../../../../../../../components/GridEditor';
import { IpAddressesTableNoDataAlert } from '../IpAddressesTableNoDataAlert';

type IpAddressesModalTableProps = {
  ipAddresses: SessionInventoryVirtualMachineDataIpAddress[];
};

export const IpAddressesModalTable = ({
  ipAddresses,
}: IpAddressesModalTableProps): ReactElement => {
  const { t } = useTranslation();

  const columns: ColDef[] = [
    {
      autoHeight: true,
      cellStyle: {
        height: 'auto',
        overflowWrap: 'anywhere',
        whiteSpace: 'normal',
      },
      field: 'name',
      flex: 1,
      headerName: t(
        'sessionsInventory.virtualMachines.ipAddressesTable.headings.adapterName',
      ),
      minWidth: 150,
    },
    {
      autoHeight: true,
      cellStyle: {
        height: 'auto',
        overflowWrap: 'anywhere',
        whiteSpace: 'normal',
      },
      field: 'networkName',
      flex: 1,
      headerName: t(
        'sessionsInventory.virtualMachines.ipAddressesTable.headings.networkName',
      ),
      minWidth: 150,
    },
    {
      autoHeight: true,
      cellStyle: {
        height: 'auto',
        overflowWrap: 'anywhere',
        whiteSpace: 'normal',
      },
      field: 'ipAddress',
      flex: 1,
      headerName: t(
        'sessionsInventory.virtualMachines.ipAddressesTable.headings.ipAddress',
      ),
      minWidth: 150,
    },
  ];

  return ipAddresses.length > 0 ? (
    <GridEditor columns={columns} data={ipAddresses} />
  ) : (
    <IpAddressesTableNoDataAlert />
  );
};
